/**
*@title 엑스포 영상, 문의처, 엑스포 구성 요소
*@date 2022-02-07
*@author 권윤성
*@desc
*@etc(change)
*/

import React from 'react';
import { Link } from "react-router-dom";
import { t } from 'i18next';

import andrewfire from "../../images_speaker/AndrewFire_crop.jpg"
import share from "../../images/share_icon.png"

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

// https://www.nature.com/articles/35888

const ConversationNobel = () => {
    const scrollToTop = () => {
        window.scrollTo(0, 0)
    }
    return(
        <div>
            {/* {window.innerWidth} */}
            <div className='cnt-section-wrap-subpages-larger' style={{marginBottom:"5%", paddingTop:"5vh"}}>
                <div className='sect-01-box-01-nobel'>
                    <div className='sect-tit'>{t("nobel_title")}</div>
                    <div className='main-nobel-subpages-lft'>
                        <img src={andrewfire}/>
                        <div className='main-nobel-speaker-name'>
                            <div>
                                <div style={{display:"inline-block"}}>
                                {t("nobel_speaker_name1")} &nbsp;
                                </div>
                                <div style={{display:"inline-block"}}>
                                {t("nobel_speaker_name2")}
                                </div>
                            </div>
                        </div>
                        <div className='main-nobel-speaker-intro-list'>
                            <ul>
                                <li>{t("nobel_speaker_intro1")}</li>
                                <li>
                                    {t("lang") === "ko"
                                    ?<a href="https://www.joongang.co.kr/article/4294545#home">
                                    {t("nobel_speaker_intro2")}<img src={share}/>
                                    </a>
                                    :<a href="https://www.nobelprize.org/prizes/medicine/2006/fire/facts/">
                                        {t("nobel_speaker_intro2")}<img src={share}/>
                                    </a>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='main-nobel-subpages-rgt'>
                        <div className='main-nobel-cont-cont-title'>
                            {t("nobel_content_title")}
                        </div>
                        <br/>
                        <div className='main-nobel-cont-cont-intro'>
                            {t("nobel_content_intro")}
                        </div>
                        <br/>
                        <br/>
                        <div className='main-nobel-cont-schedule-title'>
                            {t("nobel_topic_title")}
                        </div>
                        <div className='main-nobel-cont-schedule-cont' style={{marginBottom:"20px"}}>
                            <ul>
                                <li>{t("nobel_topic_1")}</li>
                                <li>{t("nobel_topic_2")} </li>
                                <li>{t("nobel_topic_3")} </li>
                                <li>{t("nobel_topic_4")} </li>
                                <li>{t("nobel_topic_5")} </li>
                                <li>{t("nobel_topic_6")} </li>
                            </ul>
                        </div>
                        <div className='main-nobel-cont-schedule-title'>
                            {t("nobel_time_title")}
                        </div>
                        <div className='main-nobel-cont-schedule-cont' style={{marginBottom:"20px"}}>
                            <ul>
                                <li>{t("nobel_time_date_title")}</li>
                                <ul style={{listStyle:"none"}}>
                                    <li>{t("nobel_time_date_cont")}</li>
                                </ul>
                                <li>{t("nobel_time_time_title")} </li>
                                <ul style={{listStyle:"none"}}>
                                    <li>{t("nobel_time_time_cont")}</li>
                                </ul>
                            </ul>
                        </div>
                        <div className='main-nobel-cont-schedule-title'>
                            {t("nobel_schedule_title")}
                        </div>
                        <div className='main-nobel-cont-schedule-cont'>
                            <ul>
                                <li>{t("nobel_schedule_cont1_title")}</li>
                                <ul style={{listStyle:"none"}}>
                                    <li>{t("nobel_schedule_cont1_intro")}</li>
                                </ul>
                                <li>{t("nobel_schedule_cont2_title")} </li>
                                <ul style={{listStyle:"none"}}>
                                    <li>{t("nobel_schedule_cont2_intro")}</li>
                                </ul>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className='cnt-section-wrap-subpages-larger' style={{marginTop:"0%"}}>
                <div className='sect-01-box-01-nobel'>
                    <div className='main-nobel-regi-btn-wrap'>
                        <div onClick={scrollToTop}>
                        <Link to="/visitor/registration">
                        <div className='main-nobel-regi-btn btn-color'>
                            <div className='main-nobel-regi-txt-box-wrap'>
                                <div className='main-nobel-regi-txt-box'>
                                    <div className='main-nobel-regi-txt'>
                                        {t("nobel_button")}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default ConversationNobel;